<ng-container *ngIf="!isMobile; else elseBlock">
  <button class="header-icon material-symbols-outlined" mat-mini-fab [matMenuTriggerFor]="viewdropmenu"
    #menuTrigger="matMenuTrigger" (click)="cartNavigation()" (mouseenter)="toggleMenu($event, true)"
    (mouseleave)="toggleMenu($event, false)" matBadgePosition="after" id="headerCart" 
    [ngClass]="{
      'white-outline':
        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
      'icons-background':
        environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
      'defult-background-icons':
        !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
    }">
    <mat-icon
      (mouseover)="changeIconFill=false"
      (mouseleave)="changeIconFill=true"
      class="material-icons notranslate defulat-icons-color"
      style="margin-top: -1px"
      [ngClass]="{
        'material-symbols-outlined':
          (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
        'icons-fill-color':
          environmentVariables?.HEADER_ICONS_FILL_COLOR
      }">
      {{environmentVariables?.HEADER_CART_ICON ? environmentVariables?.HEADER_CART_ICON : 'shopping_cart' }}
    </mat-icon>
    
    <!-- hidden -->
    <mat-icon
      *ngIf="false"
      class="material-icons notranslate defulat-icons-color"
      style="margin-top: -1px"
      svgIcon="thumbs-up"
      [ngClass]="{
        'material-symbols-outlined':
          (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
        'icons-fill-color':
          environmentVariables?.HEADER_ICONS_FILL_COLOR
      }">
    </mat-icon>

    <span class="header-icon__badge" *ngIf="productList?.length"
      [ngClass]="{
        'icons-background icons-fill-color':
          environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
          environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
        'defult-background-icons':
          !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
          !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND
      }">
      {{environmentVariables?.CART_COUNT_CONFIG != "items"
        ? getProductListCount(productList)
        : productList?.length
      }}
    </span>
  </button>

  <mat-menu #viewdropmenu="matMenu" [hasBackdrop]="false">
    <ng-container *ngIf="productList?.length; else elseBlock">
      <div class="position-relative" (mouseenter)="this.enteredMenu = true" (mouseleave)="closeMatMenu()">
        <app-loading *ngIf="loading"></app-loading>

        <div class="drop-wrap">
          <ng-container
            *ngIf="environmentVariables?.ENABLE_MULTI_VENDOR && environmentVariables?.SPLIT_CART_BY_VENDOR">
            <ng-container *ngFor="let p of productList; let i = index">
              <div fxFlex="row wrap" class="cart-menu-list p-2" fxLayoutAlign="start center"
                *ngFor="let product of p?.items; let i = index">
                <div fxFlex.xs="25" fxFlex.sm="25" fxFlex.md="25" fxFlex.lg="25" fxFlex.xl="25">
                  <a [routerLink]="[
                                  '/' +
                                      lang +
                                      '/products/' +
                                      product?.slug
                              ]"><img style="outline: none ; max-height: 150px;" [src]="product?.image"
                      onError="this.src='./assets/images/placeholder200.jpg';"
                      default="./assets/images/placeholder200.jpg" width="60" loading="lazy" alt="cart-image" /></a>
                </div>
                <div fxFlex.xs="75" fxFlex.sm="75" fxFlex.md="75" fxFlex.lg="75" fxFlex.xl="75" class="px-2">
                  <h6 class="mb-0">
                    <a class="no-outline product-name" [routerLink]="[
                                      '/' +
                                          lang +
                                          '/products/' +
                                          product.slug
                                  ]">
                      {{
                      lang == "en"
                      ? product?.name_en
                      : product?.name_ar
                      }}
                    </a>
                  </h6>

                  <span style="font-size: 13px !important" *ngIf="
                                  product?.price &&
                                  environmentVariables?.GUEST_CAN_VIEW_PRICES
                              " class="font-bold defult-price-color" [ngClass]="{
                                  'config-price-after-discount':
                                      product?.discount_price &&
                                      environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                  'config-price-color':
                                      environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                  'defult-price-color-after-discount':
                                      !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                      product?.discount_price,
                                  'arabic-currency': lang == 'ar'
                              }">
                    {{ product?.price | number }}
                    {{
                    lang == "en"
                    ? environmentVariables?.CURRENCY_CODE_EN
                    : environmentVariables?.CURRENCY_CODE_AR
                    }}
                  </span>
                  <br />
                  <span class="font-bold defult-price-color" *ngIf="
                                  product?.discount_price != null &&
                                  environmentVariables?.GUEST_CAN_VIEW_PRICES
                              " [ngClass]="{
                                  'config-price-before-discount':
                                      product?.discount_price &&
                                      environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                  'arabic-currency': lang == 'ar'
                              }">
                    {{ product?.discount_price | number }}
                    {{
                    lang == "en"
                    ? environmentVariables?.CURRENCY_CODE_EN
                    : environmentVariables?.CURRENCY_CODE_AR
                    }}
                    <br />
                  </span>
                  <span *ngIf="
                                  product?.price &&
                                  environmentVariables?.ENABLE_INCLUDING_VAT
                              " class="inc-vat">
                    {{ "IncVAT" | translate }}
                  </span>

                  <ng-container *ngIf="
                                  environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
                                  (product?.product_variants_options?.length >
                                      0 ||
                                      product?.options?.length > 0)
                              ">
                    <p class="mb-0" *ngFor="
                                      let options of product?.product_variants_options ||
                                          product?.options
                                  ">
                      <span class="quantity">
                        {{ options?.option?.name }}:
                        {{ options?.values[0]?.name }}
                      </span>
                    </p>
                  </ng-container>
                  <p class="mb-0" *ngIf="
                                  product?.brand &&
                                  environmentVariables?.SHOW_BRAND_ON_PRODUCT
                              ">
                    <span class="quantity">
                      {{ "productDetails.brand" | translate }}:
                      {{
                      lang == "en"
                      ? product?.brand?.name
                      : product?.brand?.name_ar
                      }}
                    </span>
                  </p>
                  <p class="mb-0" *ngIf="product?.amount">
                    <span class="quantity">
                      {{ "productDetails.quantity" | translate }}:
                      {{ product?.amount }}
                    </span>
                  </p>
                  <p class="mb-0" *ngIf="userData?.is_affiliate" [hidden]="
                                  product.commission_amount == 0 ||
                                  product.commission_amount == null
                              ">
                    <span class="commission-amount" [ngClass]="
                                      lang == 'ar' ? 'arabic-currency' : ''
                                  ">
                      {{ "orders.commission" | translate }} :
                      {{
                      product?.commission_amount
                      | number: "1.2-2"
                      }}
                      {{
                      lang == "en"
                      ? environmentVariables?.CURRENCY_CODE_EN
                      : environmentVariables?.CURRENCY_CODE_AR
                      }}
                    </span>
                  </p>
                  <app-cart-stock-validation-errors [product]="product"></app-cart-stock-validation-errors>
                </div>
                <div fxFlex.xs="35" fxFlex.sm="35" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="35"
                  class="cart-menu-action">
                  <button class="bg-secondary" mat-mini-fab mat-raised-button color="primary"
                    [routerLink]="['/' + lang + '/cart']">
                    <mat-icon class="material-icons">
                      edit
                    </mat-icon>
                  </button>
                  <button class="bg-danger" mat-mini-fab mat-raised-button color="primary"
                    (click)="decrementAmountProduct(product)" *ngIf="
                                  environmentVariables?.SHOW_DELETE_CART_ITEM_BTN
                              ">
                    <mat-icon class="material-icons">
                      delete
                    </mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>
          
          <ng-container *ngIf="!environmentVariables?.SPLIT_CART_BY_VENDOR">
            <div fxFlex="row wrap" class="cart-menu-list p-2" fxLayoutAlign="start center"
              *ngFor="let product of productList; let i = index">
              <div fxFlex.xs="25" fxFlex.sm="25" fxFlex.md="25" fxFlex.lg="25" fxFlex.xl="25">
                <a [routerLink]="[
                                '/' +
                                    lang +
                                    '/products/' +
                                    product?.slug
                            ]"><img style="outline: none ; max-height: 150px;" [src]="product?.image"
                    onError="this.src='./assets/images/placeholder200.jpg';"
                    default="./assets/images/placeholder200.jpg" width="60" loading="lazy" alt="cart-image" /></a>
              </div>
              <div fxFlex.xs="75" fxFlex.sm="75" fxFlex.md="75" fxFlex.lg="75" fxFlex.xl="75" class="px-2">
                <h6 class="mb-0">
                  <a class="no-outline product-name" [routerLink]="[
                                    '/' +
                                        lang +
                                        '/' +
                                        product?.slug
                                ]">
                    {{
                    lang == "en"
                    ? product?.name_en
                    : product?.name_ar
                    }}
                  </a>
                </h6>

                <span style="font-size: 13px !important" *ngIf="
                                product?.price &&
                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                            " class="font-bold defult-price-color" [ngClass]="{
                                'config-price-after-discount':
                                    product?.discount_price &&
                                    environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                'config-price-color':
                                    environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                'defult-price-color-after-discount':
                                    !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                    product?.discount_price,
                                'arabic-currency': lang == 'ar'
                            }">
                  {{ product?.price | number }}
                  {{
                  lang == "en"
                  ? environmentVariables?.CURRENCY_CODE_EN
                  : environmentVariables?.CURRENCY_CODE_AR
                  }}
                </span>
                <br />
                <span class="font-bold defult-price-color" *ngIf="
                                product?.discount_price != null &&
                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                            " [ngClass]="{
                                'config-price-before-discount':
                                    product?.discount_price &&
                                    environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                'arabic-currency': lang == 'ar'
                            }">
                  {{ product?.discount_price | number }}
                  {{
                  lang == "en"
                  ? environmentVariables?.CURRENCY_CODE_EN
                  : environmentVariables?.CURRENCY_CODE_AR
                  }}
                  <br />
                </span>
                <span *ngIf="
                                product?.price &&
                                environmentVariables?.ENABLE_INCLUDING_VAT
                            " class="inc-vat">
                  {{ "IncVAT" | translate }}
                </span>

                <ng-container *ngIf="
                                environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
                                (product?.product_variants_options?.length >
                                    0 ||
                                    product?.options?.length > 0)
                            ">
                  <p class="mb-0" *ngFor="
                                    let options of product?.product_variants_options ||
                                        product?.options
                                ">
                    <span class="quantity">
                      {{ options?.option?.name }}:
                      {{ options?.values[0]?.name }}
                    </span>
                  </p>
                </ng-container>
                <p class="mb-0" *ngIf="
                                product?.brand &&
                                environmentVariables?.SHOW_BRAND_ON_PRODUCT
                            ">
                  <span class="quantity">
                    {{ "productDetails.brand" | translate }}:
                    {{
                    lang == "en"
                    ? product?.brand?.name
                    : product?.brand?.name_ar
                    }}
                  </span>
                </p>
                <p class="mb-0" *ngIf="product?.amount">
                  <span class="quantity">
                    {{ "productDetails.quantity" | translate }}:
                    {{ product?.amount }}
                  </span>
                </p>
                <p class="mb-0" *ngIf="userData?.is_affiliate" [hidden]="
                                product.commission_amount == 0 ||
                                product.commission_amount == null
                            ">
                  <span class="commission-amount" [ngClass]="
                                    lang == 'ar' ? 'arabic-currency' : ''
                                ">
                    {{ "orders.commission" | translate }} :
                    {{
                    product?.commission_amount
                    | number: "1.2-2"
                    }}
                    {{
                    lang == "en"
                    ? environmentVariables?.CURRENCY_CODE_EN
                    : environmentVariables?.CURRENCY_CODE_AR
                    }}
                  </span>
                </p>
                <app-cart-stock-validation-errors [product]="product"></app-cart-stock-validation-errors>
              </div>
              <div fxFlex.xs="35" fxFlex.sm="35" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="35" class="cart-menu-action">
                <button class="bg-secondary" mat-mini-fab mat-raised-button color="primary"
                  [routerLink]="['/' + lang + '/cart']">
                  <mat-icon class="material-icons">
                    edit
                  </mat-icon>
                </button>
                <button class="bg-danger" mat-mini-fab mat-raised-button color="primary"
                  (click)="decrementAmountProduct(product)" *ngIf="
                                environmentVariables?.SHOW_DELETE_CART_ITEM_BTN
                            ">
                  <mat-icon class="material-icons">
                    delete
                  </mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="footer-menu px-3 pb-2 pt-2" [ngClass]="{'disabled' : disabledCheckout  || disabledCheckoutBtn}">
          <button mat-raised-button color="accent" class="w-100 color-primary" (click)="checkUserGuest()">
            {{ "button.buttonCheckout" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #elseBlock>
      <div class="cart-menu-list p-2 empty-list" fxLayoutAlign="center center">
        {{ "header.noProduct" | translate }}
      </div>
    </ng-template>
  </mat-menu>
</ng-container>

<ng-template #elseBlock>
  <button (click)="cartNavigation()" class="header-icon" mat-mini-fab matBadgePosition="after"
    [ngClass]="{
      'white-outline':
        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
      'icons-background':
        environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
      'defult-background-icons':
        !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR  
    }">
    <mat-icon (mouseover)="changeIconFill=false" (mouseleave)="changeIconFill=true"
      class="material-icons notranslate defulat-icons-color" style="margin-top: -1px"
      [ngClass]="{
        'material-symbols-outlined':
          (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
        'icons-fill-color':
          environmentVariables?.HEADER_ICONS_FILL_COLOR
      }">
      {{environmentVariables?.HEADER_CART_ICON ? environmentVariables?.HEADER_CART_ICON : 'shopping_cart' }}
    </mat-icon>
    <span class="header-icon__badge" *ngIf="productList?.length"
      [ngClass]="{
        'icons-background icons-fill-color':
          environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
          environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
        'defult-background-icons':
          !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
          !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND
      }">{{ productList?.length }}</span>
  </button>
</ng-template>